// extracted by mini-css-extract-plugin
export default {"root":"StuListSimple_root__X9m5d","wrapper":"StuListSimple_wrapper__I7jrH"};